// removed by extract-text-webpack-plugin
module.exports = {"content":"_21ffx-y8LkZHXm6b2R9RJO","left":"_1XsIoqj6Ytex-Tlggqz3Hg","right":"_2-fwd7IJB-c3BN-t6SY4Ri","form":"_2_SAFtlu5NETFDxfuS4i0R","heading":"_2SIEcDB2p0WIhcP4l_pjIm","codeInput":"_2evRQd-4-kIOe71BCVcyPS","submit":"_3nK4ICfGSYqNDe8Dql1N44","footer":"_3p_Jp6ggtNaZypatcyNqJ4","poweredBy":"_2-TuTlHrkemudARxYdfdNy","link":"_29wNlszMCajIi4nSdtOHz0","icon":"_3YVBzaICGnZG60EcR6AjhX","imprint":"_1suLXqX4Q_TF2tO7Qqlx92"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/paySafely/invoice/components/paySafelyInvoice.css
// module id = 498
// module chunks = 0